import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import '../styles/Search.css';

export class EmployeeAccess extends Component {
    constructor(props) {
        super(props);
        this.columns = [
            {
                name: 'Employee ID',
                selector: row => row.emplId,
            },
            {
                name: 'Last Name',
                selector: row => row.lastName,
            },
            {
                name: 'First Name',
                selector: row => row.firstName,
            },
            {
                name: 'Email Address',
                selector: row => row.emailAddress,
            },
            {
                name: 'Security Role',
                selector: row => row.securityRole,
            },
            {
                name: 'Status',
                selector: row => row.status,
            }
        ];
        this.data = [
            {
                emplId: "[Employee ID]",
                lastName: "[Last Name]",
                firstName: "[First Name]",
                emailAddress: "[Email Address]",
                securityRole: "[Security Role]",
                status: "[Status]"
            }
        ];
    }

  render () {
      return (
          <Container>
              <Container fluid className="searchInputArea border-left-dark shadow borderCurve" style={{width:"1000px", height:"auto"}}>
                  <DataTable
                      columns={this.columns}
                      data={this.data}
                  />
              </Container>
              <div>
                  <Link to="/Profile/SupplierAccess">
                      {/*<button style={{ backgroundColor: "#003C71", color: "white", border: "none", float: "right", marginTop: "10px", marginLeft: "10px", borderRadius: ".25rem" }}>Back</button>*/}
                  </Link>
              </div>
          </Container>
    );
  }
}
